import { downloadBlob, get } from '../lib/api';

function typePath(type) {
  return type ? `/${type}` : '';
}

export function downloadSoyRxPdfs(growerId, aaids, type) {
  return downloadBlob(
    `/soy/${growerId}/pdf${typePath(type)}?a=${aaids.join(',')}`,
  );
}

export function downloadSoyRxShapeFile(growerId, aaids, type) {
  return downloadBlob(
    `/soy/${growerId}/shapefile${typePath(type)}?a=${aaids.join(',')}`,
  );
}

export function getSoyRXStats(
  growerId,
  aaid,
  isBaseRate = false,
  isLate = false,
) {
  return get(
    `/growers/${growerId}/soyrx/stats/${aaid}/soyrx-${isLate ? 'late' : 'early'}?br=${Boolean(
      isBaseRate,
    )}`,
  );
}
